<template>
  <path
    d="M20.45 5.37024C20.71 4.71024 20.23 4.00024 19.52 4.00024H13H12H7V3.00024C7 2.45024 6.55 2.00024 6 2.00024C5.45 2.00024 5 2.45024 5 3.00024V4.00024V14.0002V22.0002H7V14.0002H11H12H19.52C20.23 14.0002 20.71 13.2902 20.45 12.6302L19 9.00024L20.45 5.37024ZM15 9.00024C15 10.1002 14.1 11.0002 13 11.0002C11.9 11.0002 11 10.1002 11 9.00024C11 7.90024 11.9 7.00024 13 7.00024C14.1 7.00024 15 7.90024 15 9.00024Z"
  />
</template>
